import { render, staticRenderFns } from "./DialogAddProjectForLahan.vue?vue&type=template&id=ab8455b8"
import script from "./DialogAddProjectForLahan.vue?vue&type=script&lang=js"
export * from "./DialogAddProjectForLahan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports